import React from 'react';
import { Text, Tooltip } from '@mantine/core';

interface TruncatedLocationProps {
  text: string;
  maxLength?: number;
}

const TruncatedLocation = ({ text, maxLength = 50 }: TruncatedLocationProps) => {
  if (text.length <= maxLength) {
    return <Text component="span">{text}</Text>;
  }

  const truncated = `${text.slice(0, maxLength)}...`;

  return (
    <Tooltip
      label={text}
      position="top"
      withArrow
      styles={{ body: {  whiteSpace: 'pre-wrap' } }}
    >
      <Text component="span" style={{ cursor: 'help' }}>{truncated}</Text>
    </Tooltip>
  );
};

export default TruncatedLocation;
